import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useEffect } from 'react';

interface Props {
  openDialog: boolean;
  title: string;
  message: string;
  handleConfirm: (result: boolean) => void;
}
export default function ResponsiveDialog(props: Props) {
  const { openDialog, title, message, handleConfirm } = props;

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  const handleOk = () => {
    setOpen(false);
    handleConfirm(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleConfirm(false);
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            いいえ
          </Button>
          <Button onClick={handleOk} autoFocus>
            はい
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
